import React from 'react';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '../../styles/layout.scss';
import { Award, Circle } from 'react-feather'; // Import necessary icons
import { convertData } from '../../utils/commonFunction';

function SideBar({ sidebarIsOpen }) {
  const navigate = useNavigate();

  const accessData = useSelector((state) => convertData(state.userSession.userSession));

  return (
    <div className="pt-0">
      <Sidebar collapsed={sidebarIsOpen}>
        <Menu
          menuItemStyles={{
            button: ({ level, active }) => {
              if (level === 1)
                return {
                  color: active ? 'white' : undefined,
                  backgroundColor: active ? '#7367f0' : undefined,
                  '&:hover': {
                    backgroundColor: '#7367f0',
                    color: 'white',
                  },
                };
            },
          }}
        >
          {accessData?.map((vertical, vIndex) => (
            <SubMenu
              key={vertical.key}
              id={`vertical-${vIndex}`} // Add id for vertical submenu
              icon={<Award size={18} />}
              label={vertical.key}
              className="ps-submenu-content"
              defaultOpen={
                window.location.hash.split('/')[1] === vertical.key.toString().toLowerCase() &&
                !sidebarIsOpen
              }
            >
              {vertical.children.map((project, pIndex) => (
                <SubMenu
                  key={project.key}
                  id={`project-${vIndex}-${pIndex}`} // Add id for project submenu
                  icon={<Award size={18} />}
                  label={project.key}
                  defaultOpen={
                    window.location.hash.split('/')[2] === project.key.toString().toLowerCase() &&
                    !sidebarIsOpen
                  }
                >
                  {project.children.map((module, mIndex) => (
                    <MenuItem
                      key={module.key}
                      id={`module-${vIndex}-${pIndex}-${mIndex}`} // Add id for module menu item
                      active={window.location.hash.replace('#', '') === module.navLink}
                      icon={<Circle size={12} />}
                      onClick={() => navigate(`${module.navLink}`)}
                    >
                      {module.key}
                    </MenuItem>
                  ))}
                </SubMenu>
              ))}
            </SubMenu>
          ))}
        </Menu>
      </Sidebar>
    </div>
  );
}

export default SideBar;
